module.exports = __webpack_public_path__ + "media/audio22.1013f01f.wav";